const initialState = {
    isSearchOpen: false,
    headerVisible: true
  };
  
  export const SearchReducer = {
    name: 'search',
    reducer: (state = initialState, action) => {
      switch (action.type) {
        case 'search/toggleSearch':
          return {
            ...state,
            isSearchOpen: action.payload?.forceOpen ?? !state.isSearchOpen,
            headerVisible: true
          };
        
        case 'search/setHeaderVisible':
          return {
            ...state,
            headerVisible: action.payload,
            isSearchOpen: action.payload ? state.isSearchOpen : false
          };
  
        case 'search/closeSearch':
          return {
            ...state,
            isSearchOpen: false
          };
  
        case 'search/reset':
          return initialState;
          
        default:
          return state;
      }
    },
    actions: {
      // forceOpen 파라미터 추가
      toggleSearch: (forceOpen) => ({
        type: 'search/toggleSearch',
        payload: { forceOpen }
      }),
      setHeaderVisible: (isVisible) => ({
        type: 'search/setHeaderVisible',
        payload: isVisible
      }),
      closeSearch: () => ({
        type: 'search/closeSearch'
      }),
      reset: () => ({
        type: 'search/reset'
      })
    }
  };